import React, { useEffect, useRef } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import QuoteRequestForm from "./quote-request-form";
import Resources from "./resources";
import { useStore } from "../store";
import { detectTrafficSource } from "../utils/trafficSource";
import { getOrCreateSessionId, trackPageViewGTM } from "../utils/gtm";

const Container: React.FC = () => {
  const location = useLocation();
  const { rootStore } = useStore();
  const { trackPageView: trackPageViewApi } = rootStore;
  const previousPathnameRef = useRef<string>("");

  useEffect(() => {
    // Prevent duplicate tracking for the same path
    if (previousPathnameRef.current === location.pathname) return;
    previousPathnameRef.current = location.pathname;

    const sessionId = getOrCreateSessionId();
    const {trafficSource, sourceLink} = detectTrafficSource();

    const getPageTitle = (pathname: string): string => {
      if (pathname.startsWith("/quote/")) {
        const service = pathname.replace("/quote/", "");
        return `Quote Request - ${service.replace("_", " ")} | Wellstronics3D`;
      }
      if (pathname === "/resources") {
        return "Resources | Wellstronics3D";
      }
      return document.title;
    };

    const pageTitle = getPageTitle(location.pathname);

    // Send page view to Google Tag Manager
    trackPageViewGTM({
      pagePath: location.pathname,
      pageTitle,
      sessionId,
      trafficSource,
    });

    // Also send page view to backend metrics API
    trackPageViewApi({
      pagePath: location.pathname,
      sessionId,
      trafficSource,
      sourceLink,
    });
  }, [location.pathname, trackPageViewApi]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/quote/3d_printing" />} />
      <Route path="/quote/:service" Component={QuoteRequestForm} />
      <Route path="/resources" Component={Resources} />
    </Routes>
  );
};

export default Container;
